<!--
 * @Author: 范向玲
 * @Date: 2023-5-30 13:36:08
 * @LastEditTime: 2023-5-30 13:36:08
 * @LastEditors: 范向玲
 * @Description: 贸易量数据管理--表格编辑详情表格
 * @FilePath: \src\components\DataManagement\tradeQuantity\component\edit.vue
-->
<template>
  <section class="trade-edit-container">
    <a-form
      class="trade-edit-container"
      :model="formData"
      name="basic"
      ref="formRef"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
    >
    <a-form-item label="矿种" name="commodity">
        <a-input v-model:value="formData.commodity" />
      </a-form-item>
      <a-form-item label="单位" name="unit">
        <a-input v-model:value="formData.unit" />
      </a-form-item>
      <a-form-item label="描述" name="description">
        <a-input v-model:value="formData.description" />
      </a-form-item>
    </a-form>
  </section>
</template>

<script setup>

import { ref, watch, defineProps,defineExpose, } from 'vue';


const props = defineProps({
  headerInfo: {
    type: Array,
  },
  formState: {
    type: Object,
  },
  code: {
    type: String,
  },
});

let formData = JSON.parse(JSON.stringify(props.formState));


const rules = {
  name: [{ required: true, message: '请输入!', trigger: 'blur', },],
  type: [{ required: true, message: '请输入!', trigger: 'blur', },],
  frequency: [{ required: true, message: '请输入!', trigger: 'blur', },],
  unit: [{ required: true, message: '请输入!', trigger: 'blur',},],
  source: [{ required: true, message: '请输入!', trigger: 'blur', },],
};


const formRef = ref();

defineExpose({formRef,});
watch(props.formState, (val, old) => {
  if (val) {
    formData = val;
  }
}, {
  deep: true,
  immediate: true,
});
</script>

<style lang="scss">
.trade-edit-container {
  .detail-header {
    margin: 0.1rem;
    display: flex;
    justify-content: space-between;
    .detail-infotext {
      border-left: 4px solid #f3a708;
      // width: 6.5rem;
      background-color: rgba(140, 100, 30, 0.2);
      display: flex;
      .detail-infotext-item {
        display: flex;
        margin: 0 0.05rem;
        .detail-infotext-label {
        }
      }
    }
    .crud-wrapper {
      display: flex;
      // height: 0.51rem;
      // padding: 0.13rem 0.1rem;
      .crud-item {
        margin-right: 0.04rem;
        width: 0.5rem;
        color: #fff;
        // background-color: #efb227;
        background-image: url(~@/static/images/dataManagement/curd_btn.png);
        background-size: 100% 100%;
        text-align: center;
      }
      .crud-item:hover {
        cursor: pointer;
      }
      .crud-item-disabled {
        pointer-events: none;
        color: rgba(255, 255, 255, 0.6);
        // background-color: rgba(239, 178, 39, 0.6);
        opacity: 0.8;
      }
      .crud-item-disabled:hover {
        cursor: no-drop;
      }
    }
  }
  .ant-radio-wrapper {
    color: #fff;
  }
  .ant-form-item-label > label {
    color: #fff;
  }
}
</style>
